import { useEffect, useState } from 'react';
import { getNinja, laquesisObserver } from './ninja-utils';

export default () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    getNinja().then(() => laquesisObserver.subscribe(() => setReady(true)));
  }, []);

  return {
    ready,
    isVariantEnabled: (testName, version) => ready && window.isVariantEnabled(testName, version),
    isFeatureEnabled: feat => ready && window.isFeatureEnabled(feat),
  };
};
